import classNames from "classnames"
import type React from "react"
import { withFieldLabelAndHint } from "./field"
import type { FormElement } from "./form"
import { Hint } from "./Hint"

type Props = {
  label: string | React.JSX.Element
  type?: "checkbox" | "radio"
  hint?: string
} & FormElement &
  React.InputHTMLAttributes<HTMLInputElement>

const Checkmark = ({ label, status, hint, ...inputProps }: Props) => {
  return (
    <div
      className={classNames("cobalt-CheckmarkField", {
        "cobalt-CheckmarkField--success": status === "success",
        "cobalt-CheckmarkField--error": status === "error",
      })}
    >
      <label className="cobalt-CheckmarkField__LabelWrapper">
        <input {...inputProps} className="cobalt-CheckmarkField__Input" />
        <span className="cobalt-CheckmarkField__Checkmark" />
        <span className="cobalt-CheckmarkField__Label">{label}</span>
      </label>
      {hint && (
        <Hint status={status}>
          {/** biome-ignore lint/security/noDangerouslySetInnerHtml: Allow to pass content from the HAML template*/}
          <span dangerouslySetInnerHTML={{ __html: hint }} />
        </Hint>
      )}
    </div>
  )
}

export const Checkbox = ({ label, ...props }: Props) => {
  return <Checkmark {...props} label={label} type="checkbox" />
}
Checkbox.displayName = "CobaltCheckbox"

export const Radio = ({ label, ...props }: Props) => {
  return <Checkmark {...props} label={label} type="radio" />
}
Radio.displayName = "CobaltRadio"

type ChoiceListProps = {
  children: React.ReactNode | (() => React.ReactNode)
}

const ChoiceList = ({ children }: ChoiceListProps) => {
  return (
    <div className="cobalt-ChoiceList">
      {typeof children === "function" ? children() : children}
    </div>
  )
}

const wrappedChoiceList = withFieldLabelAndHint(ChoiceList)
wrappedChoiceList.displayName = "ChoiceList"

export { wrappedChoiceList as ChoiceList }
